import { render, staticRenderFns } from "./TopPurchasedItems.vue?vue&type=template&id=9feed64a&scoped=true"
import script from "./TopPurchasedItems.vue?vue&type=script&lang=js"
export * from "./TopPurchasedItems.vue?vue&type=script&lang=js"
import style0 from "./TopPurchasedItems.vue?vue&type=style&index=0&id=9feed64a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9feed64a",
  null
  
)

export default component.exports